/* eslint-disable */
require('./bc-logo')
require('./celery')
require('./ci-logo')
require('./crustaceans')
require('./dairy')
require('./eggs')
require('./fish')
require('./gluten')
require('./halal')
require('./info')
require('./lupine')
require('./map-marker')
require('./map')
require('./menu')
require('./molluscs')
require('./mustard')
require('./noPork')
require('./nuts')
require('./omni')
require('./peel-fruits')
require('./pin')
require('./programm')
require('./sesame')
require('./soy')
require('./sulfur-dioxide')
require('./vegan')
require('./vegetarian')
require('./virus')
